<template>
  <div>
    <v-btn
      style="position: absolute; top: 0; z-index: 2000"
      v-if="absolute"
      text
      color="white"
      @click.stop="drawer = !drawer"
    >
      <v-icon>
        mdi-menu
      </v-icon>
    </v-btn>
    <v-navigation-drawer
      class="d-print-none"
      v-model="drawer"
      :color="color"
      :right="right"
      :permanent="permanent"
      :absolute="absolute"
      :temporary="temporary"
      src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
      dark
      app
      v-bind:width="250"
    >
      <div id="navigation-drawer-text">VegaMenu</div>
      <v-divider></v-divider>
      <v-list
        dense
        nav
        class="py-0"
      >
        <div
          v-for="(item, index) in items"
          :key="index">
          <v-list-item
            link
            :to="{name: `admin.${item.linkName}`}"
            v-if="item.roles.includes(currentUser.roleId)"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="primary" @click="logout">Odhlásit se</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NavigationDrawer',
  data () {
    return {
      drawer: true,
      items: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard', linkName: 'dashboard', roles: [1, 2, 3] },
        { title: 'Přehled', icon: 'mdi-notification-clear-all', linkName: 'overview', roles: [1, 2, 3, 4, 5] },
        { title: 'Jídelníčky', icon: 'mdi-view-list-outline', linkName: 'dietgroups', roles: [1, 2, 3] },
        { title: 'Databáze jídel', icon: 'mdi-database', linkName: 'foodDatabase', roles: [1, 2] },
        { title: 'Databáze nápojů', icon: 'mdi-database', linkName: 'drinksDatabase', roles: [1, 2] },
        { title: 'Databáze menu', icon: 'mdi-database', linkName: 'menuDatabase', roles: [1, 2] },
        { title: 'Nová objednávka', icon: 'mdi-cart-plus', linkName: 'newOrder', roles: [1, 2] },
        { title: 'Objednávky', icon: 'mdi-shopping-outline', linkName: 'orders', roles: [1, 2, 3, 4, 5] },
        { title: 'Archiv objednávek', icon: 'mdi-shopping', linkName: 'ordersArchive', roles: [1, 2, 3, 4, 5] },
        { title: 'Položky objednávek', icon: 'mdi-shopping-search', linkName: 'orders-items', roles: [1, 2, 3, 4, 5] },
        { title: 'Instituce', icon: 'mdi-office-building', linkName: 'institutions', roles: [1, 2] },
        { title: 'Rozvoz', icon: 'mdi-truck-delivery', linkName: 'delivery', roles: [1, 2, 3, 4, 5] },
        { title: 'Osobní odběr', icon: 'mdi-store', linkName: 'personalCollection', roles: [1, 2, 3, 4, 5] },
        { title: 'Uživatelé', icon: 'mdi-account', linkName: 'users', roles: [1, 2] },
        { title: 'Karta uživatele', icon: 'mdi-account-search', linkName: 'userCard', roles: [1, 2] },
        { title: 'Fakturační systém', icon: 'mdi-receipt', linkName: 'invoices', roles: [1, 2] },
        { title: 'Dobropisy', icon: 'mdi-receipt', linkName: 'credit', roles: [1, 2] },
        { title: 'Transakce', icon: 'mdi-bank-transfer', linkName: 'transactions', roles: [1, 2] },
        { title: 'Emaily', icon: 'mdi-email', linkName: 'emails', roles: [1, 2] },
        { title: 'Archiv jídel', icon: 'mdi-archive', linkName: 'foodArchive', roles: [1, 2] },
        { title: 'Archiv nápojů', icon: 'mdi-archive', linkName: 'drinkArchive', roles: [1, 2] },
        { title: 'Archiv menu', icon: 'mdi-archive', linkName: 'menuArchive', roles: [1, 2] },
        { title: 'Archiv uživatelů', icon: 'mdi-archive', linkName: 'userArchive', roles: [1, 2] },
        { title: 'Nastavení', icon: 'mdi-cogs', linkName: 'settings', roles: [1, 2] },
        { title: 'Testy', icon: 'mdi-test-tube', linkName: 'test', roles: [] }
      ],
      color: 'primary',
      colors: [
        'primary',
        'blue',
        'success',
        'red',
        'teal'
      ],
      right: false,
      background: false
    }
  },
  computed: {
    absolute () {
      return window.innerWidth < 600
    },
    temporary () {
      return window.innerWidth < 600
    },
    permanent () {
      return window.innerWidth > 600
    },
    expandOnHover () {
      return window.innerWidth > 600
    },
    miniVariant () {
      return window.innerWidth > 600
    },
    bg () {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  methods: {
    logout () {
      this.$http.post('/logout')
        .then(response => {
          this.$store.commit('user/clearUserData')
          this.$router.push({ name: 'login' })
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted () {
    console.log(window.innerWidth)
  }
}
</script>

<style scoped>
#navigation-drawer-text{
  text-align: center;
  color: #fffefe;
  padding: 1.5rem;
  font-size: 1.2em;
}
  .v-list-item__title{
    font-size: 0.9em !important;
  }
.v-navigation-drawer{
  width: 250px !important;
}
</style>
